import React, { useEffect, useState } from "react";
import GridItem from "../../components/Grid/GridItem.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import CustomSelectWithTooltip from "../../components/CustomInput/CustomSelectWithTooltip";

export default function CriteriaValuesForAlternatives({
  numAlternatives,
  alternativesNames,
  criteria,
  numCriteria,
  handleMatrixChange,
  handleCriteriaChange,
}) {
  const [altValues, setAltValues] = useState([]);
  const [criteriaOptions, setCriteriaOptions] = useState([]);
  const [criterionSelected, setCriterionSelected] = useState("");

  useEffect(() => {
    const alternativeArray = Array(Number(numAlternatives)).fill(null);
    setAltValues(alternativeArray);
  }, [numAlternatives]);

  useEffect(() => {
    const options = criteria.map((criterion) => {
      return {
        value: criterion.id.toString(),
        label:
          criterion.oznaka +
          " (" +
          criterion.koeficijent +
          ") - " +
          criterion.tip +
          " [" +
          criterion.jedinica_mjere +
          "]",
        details:
          criterion.oznaka +
          " " +
          criterion.naziv +
          " (" +
          criterion.koeficijent +
          ") - " +
          criterion.tip +
          " [" +
          criterion.jedinica_mjere +
          "]",
      };
    });
    setCriteriaOptions(options);
  }, [""]);

  function handleSelectChange(value) {
    setCriterionSelected(value);
    handleCriteriaChange(numCriteria, value);
  }

  return (
    <>
      <GridItem xs={12} sm={4} md={2}>
        <CustomSelectWithTooltip
          labelText="Kriterijum"
          id={numCriteria.toString()}
          options={criteriaOptions}
          value={criterionSelected}
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            value: criterionSelected,
            onChange: (event) => handleSelectChange(event.target.value),
          }}
        ></CustomSelectWithTooltip>
        {altValues.map((value, index) => (
          <div key={index}>
            <CustomInput
              id={index.toString()}
              labelText={alternativesNames[index]}
              key={value + index}
              type="number"
              formControlProps={{
                fullWidth: true,
              }}
              onChange={(event) =>
                handleMatrixChange(index, numCriteria, event.target.value)
              }
            />
          </div>
        ))}
      </GridItem>
    </>
  );
}

